import { render, staticRenderFns } from "./safetyOperGuideBookDetail.vue?vue&type=template&id=6b5ec5a4"
import script from "./safetyOperGuideBookDetail.vue?vue&type=script&lang=js"
export * from "./safetyOperGuideBookDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5ec5a4')) {
      api.createRecord('6b5ec5a4', component.options)
    } else {
      api.reload('6b5ec5a4', component.options)
    }
    module.hot.accept("./safetyOperGuideBookDetail.vue?vue&type=template&id=6b5ec5a4", function () {
      api.rerender('6b5ec5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/opm/safetyOperGuideBookDetail.vue"
export default component.exports